module.exports = "/images/new-pet-background.png?424597720b2f7cf836ab5d111263f2e6";